import { BASE_URL } from "../constants";
import { getPathFromHostname } from "../utils";

export const handleLoginSubmit = async (e, authType, username, password) => {
  e.preventDefault();

  const pathUrl = "home";
  let endpoint;
  switch (authType) {
    case 'google':
    case 'microsoft':
    case 'linkedin':
      endpoint = `${BASE_URL}/users/auth/url`;
      break;
    case 'local':
      endpoint = `${BASE_URL}/users/auth/login`;
      break;
    default:
      return;
  }
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': navigator.userAgent
      },
      body: JSON.stringify({
        email: username,
        password: password,
        authType: authType,
        from: getPathFromHostname('subdomain'),
        pathUrl: pathUrl
      })
    });
    const resp = await response.json();
    if (authType !== 'local') {
      window.location.href = resp.url;
    } else {
      if (resp.success) {
        return { success: true, data: resp.data };
      } else {
        return { success: false, message: resp.message };
      }
    }
  } catch (error) {
    console.error(error.message);
    return { success: false };
  }
};

export const handleValidateLogin = async () => {
  try {
    const response = await fetch(`${BASE_URL}/users/auth/validate-login`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': navigator.userAgent
      }
    });
    const resp = await response.json();
    if (resp.success) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.message };
    }
  } catch (error) {
    console.error(error.message);
    return { success: false };
  }
};
export const handleSignUpSubmit = async (name, username, password) => {
  try {
    const response = await fetch(`${BASE_URL}/users/register/local`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': navigator.userAgent
      },
      body: JSON.stringify({
        name: name,
        email: username,
        password: password,
      })
    });
    const resp = await response.json();
    if (resp.success) {
      return { success: true, data: resp.data, message: resp.message };
    } else {
      return { success: false, message: resp.message  };
    }
  } catch (error) {
    console.error(error.message);
    return { success: false };
  }
};

export const handleForgotPasswordSubmit = async (email) => {
  try {
    const response = await fetch(`${BASE_URL}/notifications/request-reset`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': navigator.userAgent
      },
      body: JSON.stringify({ email, host: getPathFromHostname('subdomain') })
    });
    const resp = await response.json();
    if (resp.success) {
      return { success: true, message: resp.message };
    }
    return { success: false, message: resp.message };
  } catch (error) {
    console.error(error.message);
    return { success: false, message: 'Unable to process request right now' };
  }
};
